export default function buildCommonConfig (xAxis, data, dataMin, unit) {
  return {
    tooltip: {
      trigger: 'axis',
      show: true
    },
    grid: {
      left: '5%',
      right: '5%',
      top: '20%',
      bottom: '5%',
      width: 'auto',
      height: 'auto',
      containLabel: true
    },
    color: ['#FAAA00', '#4DCBCB', '#F3667C', '#1990FF', '#6300BF', '#7B4D12', '#F2919E', '#828116'],
    legend: {},
    title: {
      text: '单位:' + unit,
      left: '0',
      top: '10',
      textStyle: {
        fontSize: 14,
        fontStyle: 'normal',
        color: 'gray'
      }
    },
    toolbox: {
      show: true,
      top: '10',
      right: '16',
      feature: {
        dataZoom: {
          yAxisIndex: 'none'
        },
        dataView: {show: false},
        restore: {},
        saveAsImage: {}
      }
    },
    xAxis: {
      type: 'category',
      boundaryGap: true,
      data: xAxis
      // axisLine: {
      //   lineStyle: {
      //     color: '#eaeaea'
      //   }
      // }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: '{value}'
      },
      min: dataMin
      // axisLine: {
      //   lineStyle: {
      //     color: '#eaeaea'
      //   }
      // }
    },
    series: data
    // [
    //   {
    //     name: '最高气温',
    //     type: 'line',
    //     data: [11, 11, 15, 13, 12, 13, 10]
    //   },
    //   {
    //     name: '最低气温',
    //     type: 'line',
    //     data: [1, -2, 2, 5, 3, 2, 0]
    //   }
    // ]

  }
}



// WEBPACK FOOTER //
// ./src/config/chart/config_extra_device_line.js